import BookingsEntry from './bookingListEntry'

const BookingsList = ({ bookingsList, onBookingClick, refreshBookings, elementColor }) => {
  return <div className="flex flex-col gap-4">
    {(bookingsList.map((booking) => (
      <div className="bookings-list flex flex-col" key={booking.id}> 
        <BookingsEntry
          booking={booking}
          onBookingClick={onBookingClick}
          refreshBookings={refreshBookings}
          elementColor={elementColor}
        />
      </div>
    ))
  )}
</div>};

export default BookingsList;
